import { actionCreatorFactory } from 'typescript-fsa';
import { FlashMessage } from '@pegasus/ui-flashmessages';

import { NAMESPACE } from './index';

export const createAction = actionCreatorFactory(NAMESPACE);
export const addClientFlashMessage = createAction<FlashMessage>('ADD_MESSAGE');
export const removeClientFlashMessage = createAction('REMOVE_MESSAGE');
